import React from 'react';
import { TikTokVideoMockup } from './TikTokVideoMockup';
import { InstagramReelMockup } from './InstagramReelMockup';
import { InstagramPostMockup } from './InstagramPostMockup';
import { YouTubeVideoMockup } from './YouTubeVideoMockup';
import { YouTubeShortMockup } from './YouTubeShortMockup';

/**
 * Renders a mockup component by type with props.
 * Used by ComparisonViewMockup to reuse existing mockup components.
 *
 * @param type - The mockup type (e.g., 'tiktok_video', 'instagram_reel')
 * @param props - Props to pass to the mockup component
 * @param key - React key for the element
 * @returns React node with the rendered mockup or error fallback
 */
export const renderMockupByType = (
  type: string,
  props: Record<string, string>,
  key: number
): React.ReactNode => {
  // Pass hideShell to render without PreviewCardShell wrapper
  const mockupProps = { ...props, hideShell: true };

  switch (type) {
    case 'tiktok_video':
      return <TikTokVideoMockup key={key} {...mockupProps} />;

    case 'instagram_reel':
      return <InstagramReelMockup key={key} {...mockupProps} />;

    case 'instagram_post':
      return <InstagramPostMockup key={key} {...mockupProps} />;

    case 'youtube_video':
      return <YouTubeVideoMockup key={key} {...mockupProps} />;

    case 'youtube_short':
      return <YouTubeShortMockup key={key} {...mockupProps} />;

    default:
      return (
        <div key={key} className="p-4 bg-zinc-800 rounded text-zinc-400 text-sm">
          Unsupported type: {type}
        </div>
      );
  }
};
